import { createReducer } from '../../../utilities';
import { scope, REFRESH_STATS } from '../../../../actions/app/other/mpp/users';
import {
    REQUEST_STATS_MPP_USERS,
    SUCCESS_FETCH_STATS_MPP_USERS,
    FAIL_FETCH_STATS_MPP_USERS
} from '../../../../actions/entities/statistics/mppUsers';

const initialStatsMPPUsersStatisticsState = {
    ids: [],
    total: null,
    info: {
        isFetching: false,
        lastPayload: null,
        needRefresh: true,
        updatedAt: null
    }
};

function requestMPPUsersStatistics(state, action) {
    return {
        ...state,
        info: {
            isFetching: true,
            lastPayload: action.payload,
            needRefresh: false,
            updatedAt: null
        }
    };
}

function successFetchMPPUsersStatistics(state, action) {
    const { total, ids, payload, receivedAt } = action;
    return {
        ...state,
        ids,
        total,
        info: {
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            updatedAt: receivedAt
        }
    };
}

function failFetchMPPUsersStatistics(state, action) {
    const { errors, payload } = action;
    return {
        ...state,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            errors
        }
    };
}

function refreshMPPUsersStatistics(state) {
    return {
        ...state,
        info: {
            ...state.info,
            needRefresh: true
        }
    };
}

export default createReducer(initialStatsMPPUsersStatisticsState, {
    [REQUEST_STATS_MPP_USERS]: requestMPPUsersStatistics,
    [SUCCESS_FETCH_STATS_MPP_USERS]: successFetchMPPUsersStatistics,
    [FAIL_FETCH_STATS_MPP_USERS]: failFetchMPPUsersStatistics,
    [REFRESH_STATS]: refreshMPPUsersStatistics,
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/other/mpp/userStats.js